export * as EmployeeSync from './employee-sync.interface';
export * as ExternalCredentials from './external-credentials.interface';
export * as Portal from './portal.interface';
export * as Recruiter from './recruiter.interface';
export * as User from './user.interface';
